import React, { useState, useContext } from "react";
import { Modal, Button, Col, Row } from "react-bootstrap";
import ReceiptSalesRecordsModal from "./ReceiptSalesRecordsModal.jsx";
import PermissionContext from "../../../Store/permission-context";
// You can use any modal library (Material UI, AntD, or plain CSS).
// Here I’m using react-bootstrap for simplicity.

const MenuModal = (props) => {
  const [showMainModal, setShowMainModal] = useState(props.showMainModal);
  const [showSubModal, setShowSubModal] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);
  const [DeleteItems, setDeleteItems] = useState(false);
  const PCtx = useContext(PermissionContext);

  //   console.log(props.ThisReceipt);
  const handleSelect = (option) => {
    let DelItem = option === "Menu A" ? true : false;
    if (option === "Menu C") {
      props.NextEvent();
    } else {
      setDeleteItems(DelItem);
      setSelectedOption(option);
      setShowMainModal(false);
      setShowSubModal(true);
    }
  };

  const handleCloseSubModal = () => {
    setShowSubModal(false);
    setSelectedOption(null);
    props.NextEvent(); // reopen main modal if you want to go back
  };

  const NextEvent2 = (reload) => {
    setShowSubModal(false);
    if (reload) {
      PCtx.setReloadReport(!PCtx.ReloadReport);
    }
    props.NextEvent();
  };

  return (
    <>
      {/* First Modal with three options */}
      <Modal
        show={showMainModal}
        onHide={() => {
          setShowMainModal(false);
          props.NextEvent();
        }}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            SELECT AN OPTION FOR {props.ThisReceipt.RInfo.RCust + "'S RECEIPT"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row className="justify-content-around">
            <Col md={10} sm={10} xs={12}>
              <Button
                variant="danger"
                className="m-2 w-75"
                onClick={() => handleSelect("Menu A")}
              >
                Delete Items Completely
              </Button>
            </Col>
            <Col md={10} sm={10} xs={12}>
              <Button
                variant="success"
                className="m-2 w-75"
                onClick={() => handleSelect("Menu B")}
              >
                Edit Items Quantity
              </Button>
            </Col>
            <Col md={10} sm={10} xs={12}>
              <Button
                variant="primary"
                className="m-2 w-75"
                onClick={() => handleSelect("Menu C")}
              >
                Reprint this Receipt
              </Button>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      {showSubModal && (
        <ReceiptSalesRecordsModal
          showmodal={showSubModal}
          modaltype={"Error"}
          paymentReceipt={props.ThisReceipt}
          NextEvent={NextEvent2}
          DeleteItems={DeleteItems}
          // Group={props.myDates.Category}
        />
      )}
    </>
  );
};

export default MenuModal;
